import React, { memo } from "react";
import { UseFormReturn } from "react-hook-form";
import { defineMessages, FormattedMessage } from "react-intl";
import { Col, FormGroup, FormLabel } from "react-bootstrap";
import { InsuranceEntity } from "../entity";
import { WitLabel } from "../styles";

const messages = defineMessages({
  active: { id: "insurance.form.active", defaultMessage: "Active" },
});

export const ActiveSwitchComponent = memo((props: UseFormReturn<InsuranceEntity>) => (
  <FormGroup as={Col}>
    <FormLabel column sm={12}>
      <WitLabel>
        <FormattedMessage {...messages.active} />
      </WitLabel>
    </FormLabel>
    <Col sm={2}>
      <div className="SwitchGroup witadmin-bs3 isActive">
        <FormGroup>
          <div>
            <label className="switch">
              <input type="checkbox" {...props.register("active")} />
              <em />
            </label>
          </div>
        </FormGroup>
      </div>
    </Col>
  </FormGroup>
));
